export default __webpack_public_path__ + "static/media/img-6.9e329b14.jpg";